import Rollbar from 'src/analytics/rollbar';

export interface Heap {
  track: (event: string, properties?: Object) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: Object) => void;
  addEventProperties: (properties: Object) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  appid: string;
  userId: string;
  identity: string | null;
  config: any;
}

export async function trackHeapSignup(userId: string | undefined) {
  const HEAP_APP_ID = '2795496137';
  const rollbarErrorMessage = 'Error tracking Heap signup';
  const heap = window.heap as Heap;

  if (!userId) {
    // This shouldn't happen since at this point we already have an user ID.
    Rollbar.trackError(rollbarErrorMessage, new Error("User ID doesn't exist"));
    return;
  }

  if (!heap) {
    Rollbar.trackError(rollbarErrorMessage, new Error('Heap not initialized'));
    return;
  }

  try {
    heap.identify(userId);
    heap.track('Signup Complete', {
      app_id: HEAP_APP_ID,
      identity: userId,
      idempotency_key: `signup-heap-${userId}`
    });
  } catch (err) {
    Rollbar.trackError(rollbarErrorMessage, err);
  }
}
